import {Component, Input, OnInit} from '@angular/core';
import {V3ExerciseSessionQuestion, V3FillMulti, V3FillMultiAnswerHolder} from "../../../../cspa/model/v3/cspa";

@Component({
    selector: 'app-fill-multi-result',
    templateUrl: './fill-multi-result.component.html',
    styleUrls: ['./fill-multi-result.component.scss'],
    standalone: false
})
export class FillMultiResultComponent implements OnInit {
  @Input() questions: V3ExerciseSessionQuestion[] = []

  constructor() { }

  ngOnInit(): void {
  }

  getQuestion(q: V3ExerciseSessionQuestion) {
    const questionDef = q.questionDef as V3FillMulti
    return questionDef.question.replace(/{\d}/g, "...")
  }

  getStudentAnswer(q: V3ExerciseSessionQuestion) {
    const answerHolder = q.questionDef?.answerDef?.answerHolder as V3FillMultiAnswerHolder | null
    return answerHolder?.answer?.map(a => a.val.join("; ")) || "-"
  }

  getCorrectAnswer(q: V3ExerciseSessionQuestion) {
    const questionDef = q.questionDef as V3FillMulti
    return questionDef.answerDef.answer.map(a => a.val.join(", ")).join("; ")
  }

  isAnswerIncorrect(q: V3ExerciseSessionQuestion) {
    const answerHolder = q.questionDef?.answerDef?.answerHolder as V3FillMultiAnswerHolder | null
    return q.score == 0 && !!answerHolder
  }
}
